import { combineReducers, createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { appReducer } from './app.reducer';
import { loaderReducer } from './loader.reducer';
import { responseReducer } from './response.reducer';
import { formReducer } from './form.reducer';
import { courseReducer } from './course.reducer';
import { cartReducer } from './cart.reducer';
import { globalReducer } from './global.reducer';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import { saveState, getPersistentStoreKey } from '../store-helpers';
var loggerMiddleware = createLogger({ diff: true, logErrors: true, errorTransformer: function (e) { console.error(e); } });
export var getStoreKey = function (integrationName, postfix) {
    return getPersistentStoreKey(integrationName) + "_" + postfix;
};
export function configureStore(storeKey, persistedState, appContext) {
    if (appContext === void 0) { appContext = {}; }
    var persistToSessionStorage = get(appContext, "persistToSessionStorage", true);
    var store = createStore(combineReducers({
        store: function (state) {
            if (state === void 0) { state = { storeKey: Symbol(storeKey) }; }
            return state;
        },
        appReducer: appReducer,
        loaderReducer: loaderReducer,
        responseReducer: responseReducer,
        formReducer: formReducer,
        courseReducer: courseReducer,
        cartReducer: cartReducer,
        globalReducer: globalReducer,
        appContext: function (state, action) {
            if (state === void 0) { state = appContext; }
            return state;
        },
    }), persistedState, applyMiddleware(thunkMiddleware, loggerMiddleware));
    if (!persistToSessionStorage) {
        return store;
    }
    store.subscribe(debounce(function () { saveState(storeKey, store.getState()); }, 1000));
    return store;
}
;
